<style scoped>
#search_results {
	padding: 5px;
	padding-top: 10px;
}
</style>

<template>
	<div id="search_results">
		<v-alert type="error" v-if="errormsg != ''">{{
			errormsg
		}}</v-alert>

		<div v-if="!loading">
			<jb-data-grid
				v-if="abooks.length > 0"
				:selected_id="selected_id"
				:can_change_columns="can_change_columns"
				:height="table_height"
				:records="abooks"

				:show_columns="show_columns"
				:available_columns="available_columns"
				@columns_changed="columns => $emit('columns_changed', columns)"

				:can_sort_columns="can_sort_columns"
				:sort_columns="sort_columns"
				@sort_changed="columns => $emit('sort_changed', columns)"

				@row_clicked="abook => $emit('click_abook', abook)"
			/>
		</div>

		<div v-if="loading">
			<v-skeleton-loader
				type="list-item-avatar-two-line"
				width="100%"
			></v-skeleton-loader>
			<v-skeleton-loader
				type="list-item-avatar-two-line"
				width="100%"
			></v-skeleton-loader>				
		</div>
	</div>
</template>

<script>
import jbdatagrid from "@/components/controls/jbdatagrid";

export default {
	props: {
		selected_id: {
			type: Number,
			default: 0
		},
		can_change_columns: { // user is allowed to change the display columns
			type: Boolean,
			default: true
		},
		can_sort_columns: { // user is allowed to change the sort columns
			type: Boolean,
			default: false
		},
		table_height: {
			type: Number,
			default: undefined
		},
		show_columns: {
			type: Array,
			default: function() { return [
				'code',
				'display_name',
			] }
		},
		sort_columns: {
			type: Array,
			default: function() { return [
				'code',
			] }
		},
	},
	data() {
		return {
			loading: false,
			iteration: 1,
			errormsg: '',
			search: {
				name: "",
				abook_types: [],
				show_columns: [],
				sort_columns: [],
			},
			abooks: [],
			available_columns: [
				{
					type: 'span',
					label: 'Code',
					name: 'code'
				},
				{
					type: 'span',
					label: 'Name',
					name: 'display_name'
				},
				{
					type: 'span',
					label: 'Country',
					name: 'country.display_name',
				},
				{
					type: 'span',
					label: 'Client Division',
					name: 'client_division.display_name',
				},
				{
					type: 'href',
					label: 'Account executive',
					name: 'acc_exec.display_name',
					uri: 'acc_exec.uri'
				},
				{
					type: 'span',
					label: 'Types',
					name: 'type_desc',
				},
			]
		}
	},
	components: {
		'jb-data-grid': jbdatagrid
	},
	methods: {
		default_columns() { 
			return [
				'code',
				'display_name',
			] 
		},
		date_to_ymd(date) {
			let year = date.getFullYear();
			let month = date.getMonth() + 1; // 0 - 11
			let day = date.getDate();

			let date_fmt = "" + year; // change it to a string!
			if (month < 10) date_fmt += "0";
			date_fmt += month; // date_fmt is already a string so this should do a string add, not math
			if (day < 10) date_fmt += "0";
			date_fmt += day; // date_fmt is already a string so this should do a string add, not math

			return date_fmt;
		},
		perform_search(new_search) {
			// We need to find out how to cancel any already running search...

			let self = this; // make sure we can access this inside of our promisses
			this.loading = true;

			// it is possible for the user to execute a new search while the previous one is still running
			// this allows us to ignore those results.
			this.iteration += 1;
			let search_iteration = this.iteration

			// copy our search
			this.search = {... new_search};

			// build our url parameters
			let params = new Array();
			if (this.search.name != '') params.push("name=" + encodeURIComponent(this.search.name));
			if (this.search.abook_types != '') params.push("abook_types=" + encodeURIComponent(this.search.abook_types));

			// build our url, we have to add url escaping here!
			let url = "/api/addressbook";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			// console.log(url);

			// look into escaping our url thingies
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + self.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					if (search_iteration == self.iteration) {
						// this is the result of the last search we've started, lets process it.
						let json = d.data;

						// For some reason axios isn't always converting our data
						if ((typeof json) == "string") {
							json = JSON.parse(json);
						}

						if (json.status == "OK") {
							// console.log("got data");

							self.abooks = json.data;
							self.errormsg = '';
						} else {
							self.errormsg = json.reason;
						}
					} else {
						// this is the result for an older search we've started, we can ignore it
						console.log("Received result set for previous search - ignored")
					}
				})
				.catch(function(e) {
					if (search_iteration == self.iteration) {
						// this is the error for the last search we've started, lets show it.
						self.errormsg = e.message;
					} else {
						// this is an error for an older search that was stil running, we can ignore it
						console.log("Received error for previous search - ignored")
					}
					console.log(e);
				})
				.finally(function() {
					if (search_iteration == self.iteration) {
						self.loading = false;

						self.$emit('content_changed');
					} else {
						// this was the result or error for a search started before the last search we did
						// we can safely ignore it. If the last search is still going loading is still true
						// if the latest search has already finished it is already being displayed and loading is already false.
					}
				});	
		},
		clear_results() {
			this.abooks = [];
		},
	},
}
</script>
